// @flow
import React from 'react';
import PageTitle from '../../components/PageTitle';

const SrcTerms = () => {
  return (
    <React.Fragment>
      <PageTitle
        breadCrumbItems={[
          { label: 'Map', path: '/apps/workorders' },
          { label: 'Terms', active: true },
        ]}
        title={'WOC terms and conditions'}
      />

      <div className="container">
        <h2 className="text-info">WOC Terms</h2>
        <p className="lead alike-update-description">
          Last Updated: September 20, 2023.
        </p>

        <p>
          This website,{' '}
          <a href="https://wo.reynoldsburg.gov">Work Order Center (WOC)</a>, is
          operated by the{' '}
          <a href="https://www.reynoldsburg.gov/" target="_blank">
            City of Reynoldsburg, Ohio
          </a>
          . Throughout the site, the terms &ldquo;we&rdquo;, &ldquo;us&rdquo;
          and &ldquo;our&rdquo; refer to the City of Reynoldsburg, Ohio. We
          offer&nbsp;this website, including all information, tools and services
          available from this site to you, the user, conditioned upon your
          acceptance of all terms, conditions, policies and notices stated here.
        </p>

        <p>
          By visiting our site, you engage in our &ldquo;Service&rdquo; and
          agree to be bound by the following terms and conditions (&ldquo;Terms
          of Service&rdquo;, &ldquo;Terms&rdquo;) These Terms of Service apply
          &nbsp;to all users of the site.
        </p>

        <p>
          Please read these Terms of Service carefully before accessing or using
          our website. By accessing or using any part of the site, you agree to
          be bound by these Terms of Service. If you do&nbsp;not agree to all
          the terms and conditions of this agreement, then you may not access
          the website or use any services.
        </p>

        <h3>1. Disclaimer</h3>

        <p>
          We provide our services using a commercially responsible level of
          skill and care and we hope that you will enjoy using them. But there
          are certain things that we don't promise about these services.
        </p>

        <h3>2. Liability for our Services</h3>
        <p>
          In order to generate usage statistics to help us improve our web site,
          we automatically collect certain information on every visitor to the
          web site. However, this information does not disclose "personal
          identifiers" (such as name, address, telephone number, e-mail address,
          etc.). Each time a request is made to view a page within this web
          site, our web site creates a log file capturing generic user
          information, Examples of this type of information includes the type of
          Internet browser or computer operating system you are using, the date
          and time you accessed this site, the Internet protocol address of the
          individual computer (or proxy server) making the request, and the
          Internet address of the site from which you may have linked to this
          site. All information collected by way of server log files is used in
          aggregate form only, and may be analyzed for trends and statistics.
        </p>

        {/* <ol type="a">
	<li>Blog articles and&nbsp;tutorials are released under <a href="http://creativecommons.org/licenses/by-nc/4.0/">CC-BY-NC license</a>.&nbsp;The code included in these articles and tutorials is licensed under <a href="https://choosealicense.com/licenses/mit/">MIT license</a>.</li>
	<li>This license shall automatically terminate if you violate any of these restrictions and may be terminated by Bootstrapious at any time. Upon terminating your viewing of these materials or upon the termination of this license, you must destroy any downloaded materials in your possession whether in electronic or printed format.</li>
</ol> */}

        <h3>3. Modifications</h3>

        <p>
          The City of Reynoldsburg, Ohio may revise these terms of service for its
          website at any time without notice. By using this website you are
          agreeing to be bound by the then current version of these terms of
          service.
        </p>

        <p>
          These terms control the relationship between the City and you. They do
          not create any third party beneficiary rights.
        </p>

        {/* <p>Version 1.0&nbsp;- Effective date: Sep 23, 2019.</p> */}
      </div>
    </React.Fragment>
  );
};

export default SrcTerms;
